const dataHooks = [
  {
    title: "useWindowResize Hook",
    shortDescription:
      "The 'Responsive' Helper. It tracks the screen size so your app can adapt to mobile or desktop views instantly.",
    description:
      "Usually, we use CSS to handle mobile layouts. But sometimes, your *logic* needs to know the screen size too—like deciding whether to load a high-quality video for desktop or a small image for mobile. This hook acts like a tape measure that never stops working. It listens for the browser's 'resize' event and constantly updates the `width` and `height` variables. It lets your JavaScript code react the moment a user shrinks their browser window.",
  },
];

export default dataHooks;